var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-square-base",
    {
      staticClass: "journey-brick",
      class: _vm.classList,
      nativeOn: {
        dblclick: function($event) {
          return _vm.onDoubleClick($event)
        }
      }
    },
    [
      [
        _vm.showOverview
          ? _c("touchpoint-overview-popup", {
              attrs: { brick: _vm.brick },
              on: {
                hide: function($event) {
                  return _vm.closeOverview()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "brick-menu" },
          [
            _vm.hasUnseenComments
              ? _c("has-unseen-comments-marker", {
                  staticClass: "has-unseen-comments-marker"
                })
              : _vm._e(),
            _vm._v(" "),
            _c("brick-dropdown-menu", {
              attrs: {
                "has-connections": _vm.hasConnections,
                "brick-id": _vm.id,
                "is-child-journey-brick": _vm.isChildJourneyBrick,
                "configured-journey-id": _vm.configuredJourneyId,
                "is-square-brick": true
              },
              on: {
                "info-click": function($event) {
                  return _vm.openOverview()
                },
                "add-connection-click": function($event) {
                  return _vm.$emit("add-connection", $event)
                },
                "delete-click": function($event) {
                  return _vm.$emit("delete-brick", true)
                },
                "settings-click": function($event) {
                  _vm.showSettings = true
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "brick-icon" },
          [
            _c("brick-icon", {
              attrs: {
                "brick-type": _vm.brick.type,
                "brick-config": _vm.brick.config
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "brick-title" }, [
          _c("span", { staticClass: "center" }, [
            _vm._v("\n                " + _vm._s(_vm.name) + "\n            ")
          ])
        ]),
        _vm._v(" "),
        _vm.showSettings
          ? _c(_vm.editorType, {
              tag: "component",
              attrs: { brick: _vm.brick, show: _vm.showSettings },
              on: {
                hidden: function($event) {
                  return _vm.onSettingsHidden()
                },
                save: function($event) {
                  return _vm.onSave($event)
                },
                delete: function($event) {
                  return _vm.onDelete()
                }
              }
            })
          : _vm._e()
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }